// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ actions
const cancelBizumActions = require('actions/contactCenter/cancelBizum');

// @ components
const CancelBizumView = require('components/contactCenter/bizum/cancelBizum/cancelBizum');

class CancelBizumViewContainer extends React.Component {
    render() {
        return (
            <CancelBizumView {...this.props} />
        );
    }
}

CancelBizumViewContainer.propTypes = {
    immCancelBizum: PropTypes.object.isRequired,
    queryContract: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
}

module.exports.constructor = CancelBizumViewContainer;
module.exports.CancelBizumViewContainer = connect(
    state => ({
        immCancelBizum: state.cancelBizum,
    }),
    {
        queryContract: cancelBizumActions.queryContract,
        validateStep: cancelBizumActions.validateStep,
        setVisibleStep: cancelBizumActions.setVisibleStep,
        handleFinish: cancelBizumActions.postCancelBizum,
        clearRequest: cancelBizumActions.clearRequest,
    }
)(CancelBizumViewContainer);
